module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-2-8aabcd488a000de7bf03e12e75e507ab.svg";